export type GenericComponentVersionInfo = {
	componentName: string;
	version: string;
	buildDateUtc: Date;
	buildId: number;
	branch: string;
	hash: string;
};

export const defaultGenericComponentVersionInfo = (): GenericComponentVersionInfo => {
	return {
		componentName: '',
		version: '',
		buildDateUtc: new Date(0),
		buildId: 0,
		branch: '',
		hash: '',
	};
};
